import { render, staticRenderFns } from "./DocAppPopup.vue?vue&type=template&id=d0b5c09c&scoped=true&"
import script from "./DocAppPopup.vue?vue&type=script&lang=js&"
export * from "./DocAppPopup.vue?vue&type=script&lang=js&"
import style0 from "./DocAppPopup.vue?vue&type=style&index=0&id=d0b5c09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b5c09c",
  null
  
)

export default component.exports